import React, { useState, useEffect } from 'react';

const API_BASE_URL = "https://final-project-5ar7.onrender.com";

// ✅ RESPONSIVE INLINE STYLES
const styles = {
  // Main Container
  container: {
    padding: '20px',
    maxWidth: '100vw',
    overflowX: 'hidden'
  },
  
  // Header Section
  header: {
    marginBottom: '30px'
  },
  
  headerTitle: (isMobile) => ({
    fontSize: isMobile ? '24px' : '32px',
    margin: '0 0 10px 0',
    fontWeight: 'bold',
    color: '#1F2937'
  }),
  
  headerSubtitle: {
    color: '#6b7280',
    margin: 0,
    fontSize: '16px'
  },
  
  // Stats Grid
  statsGrid: (isMobile) => ({
    display: 'grid',
    gridTemplateColumns: isMobile ? '1fr' : 'repeat(auto-fit, minmax(200px, 1fr))',
    gap: '20px',
    marginBottom: '30px'
  }),
  
  // Stats Card
  statsCard: {
    background: 'white',
    padding: '20px',
    borderRadius: '12px',
    boxShadow: '0 4px 6px rgba(0, 0, 0, 0.05)',
    textAlign: 'center',
    border: '1px solid #E5E7EB'
  },
  
  statsTitle: (color) => ({
    margin: '0 0 10px 0',
    color: color,
    fontSize: '16px',
    fontWeight: '600'
  }),
  
  statsValue: {
    fontSize: '24px',
    fontWeight: 'bold',
    margin: '0 0 5px 0'
  },
  
  statsSubtext: {
    color: '#6b7280',
    fontSize: '14px',
    margin: 0
  },
  
  // Tabs Container
  tabsContainer: (isMobile) => ({
    marginBottom: '20px',
    overflowX: isMobile ? 'auto' : 'visible',
    WebkitOverflowScrolling: 'touch'
  }),
  
  tabsWrapper: {
    display: 'flex',
    gap: '10px',
    borderBottom: '2px solid #e5e7eb',
    marginBottom: '20px',
    minWidth: 'max-content'
  },
  
  // Tab Button
  tab: (active, isMobile) => ({
    padding: isMobile ? '10px 16px' : '12px 20px',
    background: active ? '#3b82f6' : 'transparent',
    color: active ? 'white' : '#6b7280',
    border: 'none',
    borderRadius: '6px 6px 0 0',
    cursor: 'pointer',
    fontWeight: active ? 'bold' : 'normal',
    transition: 'all 0.2s',
    fontSize: isMobile ? '14px' : '16px',
    whiteSpace: 'nowrap',
    flexShrink: 0
  }),
  
  // Table Container
  tableContainer: {
    background: 'white',
    borderRadius: '12px',
    overflow: 'hidden',
    boxShadow: '0 4px 6px rgba(0, 0, 0, 0.05)',
    border: '1px solid #E5E7EB',
    overflowX: 'auto',
    WebkitOverflowScrolling: 'touch'
  },
  
  // Table
  table: {
    width: '100%',
    minWidth: '900px',
    borderCollapse: 'collapse'
  },
  
  // Table Header
  tableHeader: {
    background: '#F8FAFC'
  },
  
  th: (isMobile) => ({
    padding: isMobile ? '10px 8px' : '12px',
    textAlign: 'left',
    borderBottom: '2px solid #e2e8f0',
    fontSize: isMobile ? '12px' : '14px',
    fontWeight: '600',
    color: '#374151',
    whiteSpace: 'nowrap'
  }),
  
  // Table Data
  td: (isMobile) => ({
    padding: isMobile ? '10px 8px' : '12px',
    borderBottom: '1px solid #e2e8f0',
    fontSize: isMobile ? '12px' : '13px',
    verticalAlign: 'middle',
    lineHeight: '1.4'
  }),
  
  // Badge Styles
  typeBadge: (color, isMobile) => ({
    background: color,
    color: 'white',
    padding: '4px 8px',
    borderRadius: '4px',
    fontSize: isMobile ? '10px' : '12px',
    fontWeight: 'bold',
    textTransform: 'uppercase',
    whiteSpace: 'nowrap',
    display: 'inline-block'
  }),
  
  statusBadge: (color, isMobile) => ({
    background: color,
    color: 'white',
    padding: '4px 8px',
    borderRadius: '4px',
    fontSize: isMobile ? '10px' : '12px',
    textTransform: 'uppercase',
    whiteSpace: 'nowrap',
    display: 'inline-block'
  }),
  
  // Amount Display
  amount: (color, isMobile) => ({
    fontWeight: 'bold',
    fontSize: isMobile ? '14px' : '16px',
    color: color
  }),
  
  // User Info
  userInfo: (isMobile) => ({
    fontSize: isMobile ? '12px' : '14px',
    lineHeight: '1.3'
  }),
  
  userEmail: {
    color: '#6b7280',
    fontSize: '11px',
    display: 'block',
    marginTop: '2px'
  },
  
  // Empty State
  emptyState: {
    textAlign: 'center',
    padding: '60px 20px',
    color: '#6b7280',
    fontSize: '16px'
  },
  
  // Bottom Actions
  bottomActions: (isMobile) => ({
    marginTop: '30px',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    flexDirection: isMobile ? 'column' : 'row',
    gap: isMobile ? '15px' : '0'
  }),
  
  bottomLeft: {
    color: '#6b7280',
    fontSize: '14px'
  },
  
  bottomRight: {
    display: 'flex',
    gap: '10px',
    flexWrap: 'wrap'
  },
  
  // Action Button
  actionButton: (bgColor, isMobile) => ({
    background: bgColor,
    color: 'white',
    border: 'none',
    padding: isMobile ? '8px 12px' : '10px 16px',
    borderRadius: '6px',
    cursor: 'pointer',
    display: 'flex',
    alignItems: 'center',
    gap: '6px',
    fontSize: isMobile ? '13px' : '14px',
    fontWeight: '500',
    transition: 'all 0.2s ease',
    whiteSpace: 'nowrap'
  }),
  
  // Loading State
  loading: {
    padding: '60px 20px',
    textAlign: 'center',
    fontSize: '18px',
    color: '#6b7280'
  }
};

function TransactionHistory() {
  const [deposits, setDeposits] = useState([]);
  const [withdrawals, setWithdrawals] = useState([]);
  const [loading, setLoading] = useState(true);
  const [activeTab, setActiveTab] = useState('all');
  const [combinedTransactions, setCombinedTransactions] = useState([]);
  const [isMobile, setIsMobile] = useState(false);
  const [isTablet, setIsTablet] = useState(false);

  // ✅ Detect Device Type
  useEffect(() => {
    const checkDevice = () => {
      const width = window.innerWidth;
      setIsMobile(width <= 768);
      setIsTablet(width > 768 && width <= 1024);
    };
    
    checkDevice();
    window.addEventListener('resize', checkDevice);
    
    return () => window.removeEventListener('resize', checkDevice);
  }, []);

  useEffect(() => {
    fetchAllTransactions();
  }, []);

  const fetchAllTransactions = async () => {
    try {
      setLoading(true);
      
      const [depositsRes, withdrawalsRes] = await Promise.all([
        fetch(`${API_BASE_URL}/api/admin/public/all-deposits`),
        fetch(`${API_BASE_URL}/api/admin/public/all-withdrawals`)
      ]);

      const depositsData = await depositsRes.json();
      const withdrawalsData = await withdrawalsRes.json();

      setDeposits(Array.isArray(depositsData) ? depositsData : []);
      setWithdrawals(Array.isArray(withdrawalsData) ? withdrawalsData : []);

      // Combine and sort all transactions
      const combined = [
        ...depositsData.map(d => ({ ...d, type: 'deposit' })),
        ...withdrawalsData.map(w => ({ ...w, type: 'withdrawal' }))
      ].sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt));

      setCombinedTransactions(combined);
      setLoading(false);
    } catch (error) {
      console.error('Error fetching transactions:', error);
      setLoading(false);
    }
  };

  const getStatusColor = (status) => {
    switch (status) {
      case 'submitted': return '#f59e0b';
      case 'pending': return '#3b82f6';
      case 'approved': return '#10b981';
      case 'rejected': return '#ef4444';
      default: return '#6b7280';
    }
  };

  const getTypeColor = (type) => {
    return type === 'deposit' ? '#10b981' : '#ef4444';
  };

  const filteredTransactions = () => {
    switch (activeTab) {
      case 'deposits': return combinedTransactions.filter(t => t.type === 'deposit');
      case 'withdrawals': return combinedTransactions.filter(t => t.type === 'withdrawal');
      default: return combinedTransactions;
    }
  };

  // ✅ Export to CSV Function
  const exportToCSV = () => {
    const csvContent = [
      ['Date', 'Type', 'User', 'Account', 'Amount', 'Status', 'Gateway', 'Notes'],
      ...filteredTransactions().map(t => [
        new Date(t.createdAt).toLocaleDateString(),
        t.type,
        t.type === 'deposit' 
          ? `${t.userId?.firstName} ${t.userId?.lastName}` 
          : t.fullName,
        t.tradeAccount,
        t.amount,
        t.status,
        t.gateway || 'KYC Withdrawal',
        t.adminNotes || ''
      ])
    ].map(row => row.join(',')).join('\n');
    
    const blob = new Blob([csvContent], { type: 'text/csv' });
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = `transactions-${new Date().toISOString().split('T')[0]}.csv`;
    a.click();
  };

  if (loading) {
    return (
      <div style={styles.container}>
        <div style={styles.loading}>
          🔄 Loading transaction history...
        </div>
      </div>
    );
  }

  return (
    <div style={styles.container}>
      {/* Header */}
      <div style={styles.header}>
        <h1 style={styles.headerTitle(isMobile)}>Transaction History</h1>
        <p style={styles.headerSubtitle}>View complete transaction history and reports.</p>
      </div>

      {/* Summary Stats */}
      <div style={styles.statsGrid(isMobile)}>
        <div style={styles.statsCard}>
          <h3 style={styles.statsTitle('#10b981')}>Total Deposits</h3>
          <p style={styles.statsValue}>
            ${deposits.reduce((sum, d) => sum + parseFloat(d.amount || 0), 0).toLocaleString()}
          </p>
          <small style={styles.statsSubtext}>{deposits.length} transactions</small>
        </div>

        <div style={styles.statsCard}>
          <h3 style={styles.statsTitle('#ef4444')}>Total Withdrawals</h3>
          <p style={styles.statsValue}>
            ${withdrawals.reduce((sum, w) => sum + parseFloat(w.amount || 0), 0).toLocaleString()}
          </p>
          <small style={styles.statsSubtext}>{withdrawals.length} transactions</small>
        </div>

        <div style={styles.statsCard}>
          <h3 style={styles.statsTitle('#3b82f6')}>Net Flow</h3>
          <p style={styles.statsValue}>
            ${(
              deposits.reduce((sum, d) => sum + parseFloat(d.amount || 0), 0) - 
              withdrawals.reduce((sum, w) => sum + parseFloat(w.amount || 0), 0)
            ).toLocaleString()}
          </p>
          <small style={styles.statsSubtext}>Total net inflow</small>
        </div>

        <div style={styles.statsCard}>
          <h3 style={styles.statsTitle('#9333ea')}>Total Transactions</h3>
          <p style={styles.statsValue}>
            {combinedTransactions.length}
          </p>
          <small style={styles.statsSubtext}>All time</small>
        </div>
      </div>

      {/* Filter Tabs */}
      <div style={styles.tabsContainer(isMobile)}>
        <div style={styles.tabsWrapper}>
          {[
            { key: 'all', label: 'All Transactions', count: combinedTransactions.length },
            { key: 'deposits', label: 'Deposits', count: deposits.length },
            { key: 'withdrawals', label: 'Withdrawals', count: withdrawals.length }
          ].map(tab => (
            <button
              key={tab.key}
              onClick={() => setActiveTab(tab.key)}
              style={styles.tab(activeTab === tab.key, isMobile)}
            >
              {tab.label} ({tab.count})
            </button>
          ))}
        </div>
      </div>

      {/* Transactions Table */}
      <div style={styles.tableContainer}>
        <table style={styles.table}>
          <thead style={styles.tableHeader}>
            <tr>
              <th style={styles.th(isMobile)}>Date</th>
              <th style={styles.th(isMobile)}>Type</th>
              <th style={styles.th(isMobile)}>User</th>
              <th style={styles.th(isMobile)}>Account</th>
              <th style={styles.th(isMobile)}>Amount</th>
              <th style={styles.th(isMobile)}>Status</th>
              <th style={styles.th(isMobile)}>Gateway</th>
              <th style={styles.th(isMobile)}>Notes</th>
            </tr>
          </thead>
          <tbody>
            {filteredTransactions().length === 0 ? (
              <tr>
                <td colSpan={8} style={styles.emptyState}>
                  No transactions found
                </td>
              </tr>
            ) : (
              filteredTransactions().map((transaction) => (
                <tr key={`${transaction.type}-${transaction._id}`}>
                  <td style={styles.td(isMobile)}>
                    <div>
                      {new Date(transaction.createdAt).toLocaleDateString()}
                    </div>
                    {!isMobile && (
                      <small style={{ color: '#6b7280' }}>
                        {new Date(transaction.createdAt).toLocaleTimeString()}
                      </small>
                    )}
                  </td>
                  <td style={styles.td(isMobile)}>
                    <span style={styles.typeBadge(getTypeColor(transaction.type), isMobile)}>
                      {transaction.type}
                    </span>
                  </td>
                  <td style={styles.td(isMobile)}>
                    <div style={styles.userInfo(isMobile)}>
                      {transaction.type === 'deposit' ? (
                        <>
                          <div>{transaction.userId?.firstName} {transaction.userId?.lastName}</div>
                          <small style={styles.userEmail}>{transaction.userId?.email}</small>
                        </>
                      ) : (
                        <>
                          <div>{transaction.fullName}</div>
                          <small style={styles.userEmail}>{transaction.userId?.email}</small>
                        </>
                      )}
                    </div>
                  </td>
                  <td style={styles.td(isMobile)}>
                    <div style={{ fontFamily: 'monospace', fontSize: isMobile ? '11px' : '12px' }}>
                      {transaction.tradeAccount}
                    </div>
                  </td>
                  <td style={styles.td(isMobile)}>
                    <span style={styles.amount(getTypeColor(transaction.type), isMobile)}>
                      {transaction.type === 'withdrawal' ? '-' : '+'}${transaction.amount}
                    </span>
                  </td>
                  <td style={styles.td(isMobile)}>
                    <span style={styles.statusBadge(getStatusColor(transaction.status), isMobile)}>
                      {transaction.status}
                    </span>
                  </td>
                  <td style={styles.td(isMobile)}>
                    {transaction.gateway ? (
                      <span style={{ fontSize: isMobile ? '10px' : '12px' }}>
                        {transaction.gateway.replace(/_/g, ' ').toUpperCase()}
                      </span>
                    ) : (
                      <span style={{ color: '#6b7280', fontSize: isMobile ? '10px' : '12px' }}>
                        KYC Withdrawal
                      </span>
                    )}
                  </td>
                  <td style={styles.td(isMobile)}>
                    {transaction.adminNotes ? (
                      <span style={{ 
                        fontSize: isMobile ? '11px' : '14px', 
                        color: '#6b7280',
                        display: 'block',
                        maxWidth: '120px',
                        overflow: 'hidden',
                        textOverflow: 'ellipsis',
                        whiteSpace: 'nowrap'
                      }}>
                        {transaction.adminNotes}
                      </span>
                    ) : (
                      <span style={{ color: '#9ca3af' }}>-</span>
                    )}
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>

      {/* Bottom Actions */}
      <div style={styles.bottomActions(isMobile)}>
        <div style={styles.bottomLeft}>
          Showing {filteredTransactions().length} transactions
        </div>
        
        <div style={styles.bottomRight}>
          <button
            onClick={fetchAllTransactions}
            style={styles.actionButton('#3b82f6', isMobile)}
            onMouseEnter={(e) => e.target.style.background = '#2563EB'}
            onMouseLeave={(e) => e.target.style.background = '#3b82f6'}
          >
            🔄 Refresh
          </button>
          
          <button
            onClick={exportToCSV}
            style={styles.actionButton('#10b981', isMobile)}
            onMouseEnter={(e) => e.target.style.background = '#059669'}
            onMouseLeave={(e) => e.target.style.background = '#10b981'}
          >
            📥 Export CSV
          </button>
        </div>
      </div>
    </div>
  );
}

export default TransactionHistory;
